import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import apiClient from '../api/apiClient';
import { assignSessionId } from '../features/session/sessionId';

const submitInputsFn = async (inputs) => {
  console.dir(inputs);

  const response = await apiClient.post('api/inputspush', inputs);
  return response.data;
};

export function useSubmitInputs() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: submitInputsFn,
    onSuccess: (data) => {
      if (data.sessionId) {
        sessionStorage.setItem(
          'sessionId',
          JSON.stringify({ value: data.sessionId }),
        );
        dispatch(assignSessionId(data.sessionId));
      }
      // Invalidate stale results so useResultPull fetches fresh data
      queryClient.invalidateQueries({ queryKey: ['results'] });
    },
  });

  return {
    submitInputs: mutation.mutate,
    isSubmitting: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
